// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"342":"c01bf1ca","951":"0dcb6721"}[chunkId] + ".css";
};